import { useIsTablet } from "@/config/hooks";
import { PspLogoProps } from "./PspLogo.types";

export default function PspLogo({ width }: PspLogoProps) {
  const isTablet = useIsTablet();

  return (
    <img
      src="/logo.svg"
      className="tablet:w-80"
      style={{
        width: width ? `${width / 4}rem` : `${isTablet ? 16 : 12.5}rem`,
      }}
    />
  );
}
